import { c as _c } from "react/compiler-runtime";
import { Modal, NeutralButton, PrimaryButton, RadioGroup, SecondaryButton } from '@systemeio/ui';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { useCancelSplitTest } from 'modules/newsletters/split-test/hooks/use-cancel-split-test';
import { NewsletterSplitTestInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface StopSplitTestModalProps {
  mailingSplitTest: NewsletterSplitTestInterface;
  newsletterId: NewsletterId;
}
export const CancelSplitTestModal = t0 => {
  const $ = _c(76);
  const {
    mailingSplitTest,
    newsletterId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(mailingSplitTest.mailingVariantA.id);
  const {
    cancelSplitTest,
    isFetching
  } = useCancelSplitTest();
  let t1;
  if ($[0] !== newsletterId) {
    t1 = {
      newsletterId
    };
    $[0] = newsletterId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutateNewslettersData
  } = useGetNewsletterView(t1);
  const t2 = mailingSplitTest.mailingVariantA.id;
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.newsletter_editor.split_test.variant_a");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== mailingSplitTest.mailingVariantA.id || $[5] !== t3) {
    t4 = {
      id: t2,
      caption: t3
    };
    $[4] = mailingSplitTest.mailingVariantA.id;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = mailingSplitTest.mailingVariantB.id;
  let t6;
  if ($[7] !== t) {
    t6 = t("dashboard.newsletter_editor.split_test.variant_b");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== mailingSplitTest.mailingVariantB.id || $[10] !== t6) {
    t7 = {
      id: t5,
      caption: t6
    };
    $[9] = mailingSplitTest.mailingVariantB.id;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = [t4, t7];
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const customerTypeData = t8;
  let t9;
  if ($[15] !== cancelSplitTest || $[16] !== mutateNewslettersData || $[17] !== newsletterId || $[18] !== router || $[19] !== selected) {
    t9 = async () => {
      ;
      try {
        await cancelSplitTest(newsletterId, selected);
        await mutateNewslettersData();
        await router.replace({
          pathname: router.asPath.split("?variant")[0]
        }, undefined, {
          shallow: true
        });
        setOpened(false);
      } catch (t10) {
        const e = t10;
        throw e;
      }
    };
    $[15] = cancelSplitTest;
    $[16] = mutateNewslettersData;
    $[17] = newsletterId;
    $[18] = router;
    $[19] = selected;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const handelCancelSplitTest = t9;
  let t10;
  if ($[21] !== mailingSplitTest.mailingVariantA.id) {
    t10 = () => {
      setOpened(false);
      setSelected(mailingSplitTest.mailingVariantA.id);
    };
    $[21] = mailingSplitTest.mailingVariantA.id;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const onClose = t10;
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setOpened(true);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("dashboard.newsletter_editor.split_test.stop_modal_button");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <NeutralButton onClick={t11}><span>{t12}</span></NeutralButton>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== onClose) {
    t14 = () => onClose();
    $[28] = onClose;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("dashboard.newsletter_editor.split_test.stop_modal_title");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("dashboard.newsletter_editor.split_test.stop_modal_text");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <p className="text-text-primary text-base">{t16}</p>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("dashboard.newsletter_editor.split_test.save_and_test.selected_variant");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = value => setSelected(value);
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== customerTypeData || $[40] !== selected || $[41] !== t18) {
    t20 = <RadioGroup className="items-center" label={t18} selected={selected} options={customerTypeData} onChange={t19} />;
    $[39] = customerTypeData;
    $[40] = selected;
    $[41] = t18;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t17 || $[44] !== t20) {
    t21 = <div className="flex flex-col items-center gap-6">{t17}{t20}</div>;
    $[43] = t17;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== onClose) {
    t22 = () => onClose();
    $[46] = onClose;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("global.cancel");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== isFetching || $[51] !== t22 || $[52] !== t23) {
    t24 = <SecondaryButton className="w-full" onClick={t22} width="large" disabled={isFetching}>{t23}</SecondaryButton>;
    $[50] = isFetching;
    $[51] = t22;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== handelCancelSplitTest) {
    t25 = () => handelCancelSplitTest();
    $[54] = handelCancelSplitTest;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t) {
    t26 = t("global.save");
    $[56] = t;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== isFetching || $[59] !== t25 || $[60] !== t26) {
    t27 = <PrimaryButton className="w-full" width="large" onClick={t25} isFetching={isFetching}>{t26}</PrimaryButton>;
    $[58] = isFetching;
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t24 || $[63] !== t27) {
    t28 = <div className="flex justify-center gap-4">{t24}{t27}</div>;
    $[62] = t24;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t21 || $[66] !== t28) {
    t29 = <div className="flex flex-col gap-6 lg:gap-10">{t21}{t28}</div>;
    $[65] = t21;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== opened || $[69] !== t14 || $[70] !== t15 || $[71] !== t29) {
    t30 = <Modal isCentered={true} opened={opened} onClose={t14} title={t15}>{t29}</Modal>;
    $[68] = opened;
    $[69] = t14;
    $[70] = t15;
    $[71] = t29;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== t13 || $[74] !== t30) {
    t31 = <>{t13}{t30}</>;
    $[73] = t13;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  return t31;
};